export const supports = [
  "Women's health & hormonal balance",
  'Menstrual health, fibroids & PCOS',
  'Menopause & perimenopause',
  'Stress & emotional wellbeing',
  'Digestive health',
  'Chronic fatigue',
  'High blood pressure & diabetes support',
  'Immune support',
  'General wellness & prevention',
]

export const howItWorks = [
  {
    step: '01',
    title: 'Submit Your Enquiry',
    desc: 'Fill in the booking form with your name, contact details, preferred time, and a brief overview of your health concerns.',
  },
  {
    step: '02',
    title: 'Kandake Calls You Back',
    desc: 'Kandake will personally contact you to discuss your needs, answer questions, and confirm your appointment.',
  },
  {
    step: '03',
    title: 'Your Consultation',
    desc: 'A thorough one-to-one session exploring root causes, your health history, lifestyle, and wellbeing goals.',
  },
  {
    step: '04',
    title: 'Your Personalised Plan',
    desc: 'You receive a tailored herbal medicine protocol, lifestyle guidance, and nutritional recommendations to support your healing.',
  },
]
